import React from "react";
import "./ClickableText.scss";
import classNames from "classnames";
import { handleEnterKeypress } from "../../utils/keyEvents";
import { withDefaults } from "../../utils/withDefaults";
import type { ButtonActivationEvent } from "../button/button";

export interface ClickableTextProps {
  onClick?: (event: ButtonActivationEvent) => void;
  className?: string;
  isInDarkBackground?: boolean;
  buttonRef?: React.Ref<HTMLButtonElement>;
  children?: React.ReactNode;
}

export default function ClickableText(incomingProps: ClickableTextProps) {
  const props = withDefaults(incomingProps, clickableTextDefaultProps);

  const handleKeyPress = (event: React.KeyboardEvent) => handleEnterKeypress(event, props.onClick);
  const getContextClassName = () =>
    props.isInDarkBackground ? "dark-background" : "light-background";

  return (
    <button
      className={classNames(
        "clickable-text",
        props.className,
        getContextClassName()
      )}
      onClick={props.onClick}
      onKeyPress={handleKeyPress}
      tabIndex={0}
      ref={props.buttonRef}
    >
      {props.children}
    </button>
  );
}

const clickableTextDefaultProps = {
  onClick: () => {},
  className: "",
  isInDarkBackground: false,
  buttonRef: null
};
